<template>
  <div class="mobile_games">
  <div class="swiper">
    <div class="swiper-wrapper owl-carousel g-button" style="z-index:0">
      <span v-for="(game, index) in games" :key="index">
        <div v-if="game.shown" class="swiper-slide">
          <div :class="['game_box', game.class]" @click.prevent="navigateToGameIntro(game.nav)" style="cursor:pointer">
              <img :src="[game.icon]">
              <p v-if="game.nav==='LOGIC'"> {{ getTranslations.home_gametype_logic }} </p>
              <p v-if="game.nav==='MEMORY'"> {{ getTranslations.home_gametype_memory }} </p>
              <p v-if="game.nav==='ATTENTION'"> {{ getTranslations.home_gametype_attention }} </p>
            </div>
        </div>
      </span>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import 'owl.carousel';
import modals from '@/common/modals';
import PreGameModal from './modals/pregame/PreGameModal';

export default {
  name: 'games-carousel-mobile',
  data() {
    /*eslint-disable */
    return {
      games: [ // mixed import object as prop, in order to use it for desktop as well
        {
          nav: 'LOGIC',
          class: 'logic',
          icon: 'static/images/games/icon-logic.png',
          shown: true,
        },
        {
          nav: 'MEMORY',
          class: 'memory',
          icon: 'static/images/games/icon-memory.png',
          shown: true,
        },
        {
          nav: 'ATTENTION',
          class: 'attention',
          icon: 'static/images/games/icon-attention.png',
          shown: true,
        },
      ],
    };
  },
  mounted() {
    this.initOwlCarousel();
  },
  methods: {
    ...mapMutations('game', [
      'updateGameType',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    navigateToGameIntro(game) {
      /* eslint-disable */
      console.log('NAV GAME -> ', game);
      this.storeModalForHomePage(PreGameModal);
      this.updateGameType(game);
      modals.showHideModal(this);
    },
    initOwlCarousel() {
      /*eslint-disable */
      $('.g-button').owlCarousel({
        items: 3,
        autoplay: false,
        loop: false,
        responsive: {
          321: {
            items: 3,
          },
          0: {
            items: 2,
          },
        },
      });
      setTimeout(()=>{$('.owl-carousel').trigger('refresh.owl.carousel');}, 200);
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/GamesCarouselMobile.vue